<template>
  <r-toggle-card
    title="Информация"
    :is-open="layerStyle.popup.enabled"
    @toggle="toggleHandler"
  >
    <r-text style="margin-bottom: 4px;" type="caption">
      Отображаемые атрибуты
    </r-text>
    <source-attributes
      :single="false"
      :active-fields="layerStyle.popup.fields"
      @handleNodeClick="changeField($event)"
      :tree-data="getAttributes(objectFields, true, false)"
    />
  </r-toggle-card>
</template>

<script>
import SourceAttributes from "@/components/map/components/source-attributes/source-attributes";
import { getAttributes, updateObjectFieldsConfigs } from "@/utils";

export default {
  props: ["id", "layer-style", "layer-controller", "title"],
  components: {
    SourceAttributes
  },
  watch: {
    id: function() {
      this.objectFields = this.$clientStore.getDataFields(
        this.$store.state.profiles.sourceIdById[this.id]
      );
    }
  },
  data() {
    return {
      moreShown: false,
      objectFields: this.$clientStore.getDataFields(
        this.$store.state.profiles.sourceIdById[this.id]
      )
    };
  },
  methods: {
    toggleHandler(value) {
      this.layerStyle.popup.enabled = value;
    },
    changeField({ path, config }) {
      const { fields } = this.layerStyle.popup;
      const index = fields.indexOf(path);

      if (index > -1) fields.splice(index, 1);
      else fields.push(path);

      updateObjectFieldsConfigs(
        this.layerController.map,
        this.id,
        path,
        config
      );
      this.layerController.updateLayerData(this.id, fields);
    },
    getAttributes
  }
};
</script>

<style lang="scss">
.popup-fields-picker {
  &__container {
    padding-left: 10px;
  }

  &__attributes {
    margin-top: 15px;
  }
}
</style>
